/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';
import 'flickity-imagesloaded';

export function iconSlider() {
  var slider = document.querySelector('.iconSlider');
  var flkty = new Flickity(slider, {
    // options
    imagesLoaded: true,
    cellAlign: 'center',
    cellSelector: 'img',
    contain: true,
    wrapAround: true,
    pageDots: true,
    prevNextButtons: false,
    adaptiveHeight: false,
    watchCSS: true
  });

  var tapArea, startX ;
    tapArea = document.querySelectorAll('.iconSlider');
    startX = 0;
    for (var item of tapArea) {
      item.ontouchstart = function(e) {
          startX = e.touches[0].clientX;
      };
      item.ontouchmove = function(e) {
          if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
              e.preventDefault();
          }
      };
  }
}

